import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from "./shared/shared.module";
import { CoreModule } from "./core/core.module";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './shared/interceptors/loader.interceptor';
import { environment } from '../environments/prod/environment';
import { ApiInterceptor } from './shared/interceptors/api.interceptor';

// export function initializeAppCustomLogic(
//   authorizationService: AuthorizationService,
//   globalEventsService: GlobalEventsService
// ): () => Observable<any> {
//   return () => authorizationService.logIn()
// }

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    ReactiveFormsModule,
    BrowserAnimationsModule
  ],
  bootstrap: [AppComponent],
  providers: [
    {
       provide: HTTP_INTERCEPTORS,
       useClass: LoaderInterceptor,
       multi: true,
    },
    {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true}
  ]
  // providers: [{
  //   provide: APP_INITIALIZER,
  //   useFactory: initializeAppCustomLogic,
  //   deps: [AuthorizationService, GlobalEventsService],
  //   multi: true
  // }]
})
export class AppModule {
}
